"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocationListSelector = exports.checkBoxFilters = exports.default = void 0;

var _attributeIds = _interopRequireDefault(require("@devsontap/nica-api/core/utils/attributeIds"));

var _underscore = _interopRequireDefault(require("underscore"));

var _index = require("../index");

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INITIAL_STATE = {
  loading: true,
  locationLoading: true,
  locations: null,
  filteredLocationIds: null,
  filteredLocationIdsString: "",
  locationMap: {},
  visibleIds: null,
  error: null,
  filter: _getDefaultFilter(),
  searchRadius: 30,
  lastSearch: null,
  lastSearchId: null,
  lastSearchQuery: "initial",
  lastPageViewId: null
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _types.LOCATIONS_LOADING:
      var radius = action.payload.radius;
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        error: null,
        lastSearch: action.payload,
        searchRadius: radius
      });

    case _types.LOCATIONS_SUCCESS:
      var _action$payload = action.payload,
          locations = _action$payload.locations,
          searchId = _action$payload.searchId;

      var newFilteredLocationIds = _applyFilters(locations, state.filter);

      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        locations: locations,
        locationMap: locations.reduce(function (ret, location) {
          ret[location.id] = location;
          return ret;
        }, state.locationMap),
        filteredLocationIds: newFilteredLocationIds,
        filteredLocationIdsString: JSON.stringify(newFilteredLocationIds),
        // visibleIds: filteredLocations.map(location => location.id)
        lastSearchId: searchId
      });

    case _types.LOCATIONS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action.error
      });

    case _types.LOCATIONS_UPDATE_FILTER:
      var filter = _objectSpread(_objectSpread({}, state.filter), {}, _defineProperty({}, action.payload.filterKey, action.payload.value));

      var updatedFilteredLocationIds = _applyFilters(state.locations, filter);

      return _objectSpread(_objectSpread({}, state), {}, {
        filter: filter,
        filteredLocationIds: updatedFilteredLocationIds,
        filteredLocationIdsString: JSON.stringify(updatedFilteredLocationIds)
      });

    case _types.LOCATIONS_UPDATE_ORGID:
      var location = state.locationMap[action.payload];
      return _objectSpread(_objectSpread({}, state), {}, {
        locationMap: _objectSpread(_objectSpread({}, state.locationMap), {}, _defineProperty({}, action.payload, _objectSpread(_objectSpread({}, location), {}, {
          orgId: -1
        })))
      });

    case _types.LOCATIONS_GEOCODING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        lastSearchQuery: action.payload
      });

    case _types.LOCATIONS_CLEAR_FILTERS:
      var locationIds = state.locations && state.locations.map(function (location) {
        return location.id;
      });
      var json = JSON.stringify(locationIds);
      return _objectSpread(_objectSpread({}, state), {}, {
        filter: _getDefaultFilter(),
        filteredLocationIds: locationIds,
        filteredLocationIdsString: json
      });

    case _types.LOCATION_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        locationLoading: true
      });

    case _types.LOCATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        locationLoading: false,
        locationMap: _objectSpread(_objectSpread({}, state.locationMap), {}, _defineProperty({}, action.payload.id, action.payload))
      });

    case _types.LOCATION_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          locationLoading: false
        });
      }

    case _types.LOCATION_PAGE_VIEW:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          lastPageViewId: action.payload
        });
      }

    default:
      return state;
  }
};

exports.default = _default;
var checkBoxFilters = [{
  label: "Open Weekends",
  key: "openWeekends",
  apply: function apply(location) {
    return location.businessHours && (location.businessHours.saturdayOpen || location.businessHours.sundayOpen);
  }
}, {
  key: "acceptsOutsidePatients",
  label: "Accepts patients from outside doctors",
  apply: function apply(location) {
    return location.attributes[_attributeIds.default.acceptsOutsidePatients] != null && _underscore.default.contains(location.attributes[_attributeIds.default.acceptsOutsidePatients].choice, _attributeIds.default.acceptsOutsidePatientsYes);
  }
}, {
  key: "hideHospitalBased",
  label: "Hide hospital based locations",
  apply: function apply(location) {
    return location.attributes[_attributeIds.default.facilityType] != null && !_underscore.default.contains(location.attributes[_attributeIds.default.facilityType].choice, _attributeIds.default.hospitalBased);
  }
}, {
  key: "acceptsMedicaid",
  label: "Accepts Medicaid",
  apply: function apply(location) {
    return location.attributes[_attributeIds.default.acceptedHealthCarePlans] != null && _underscore.default.contains(location.attributes[_attributeIds.default.acceptedHealthCarePlans].choice, _attributeIds.default.acceptsMedicaid);
  }
}, {
  key: "acceptsMedicare",
  label: "Accepts Medicare",
  apply: function apply(location) {
    return location.attributes[_attributeIds.default.acceptedHealthCarePlans] != null && _underscore.default.contains(location.attributes[_attributeIds.default.acceptedHealthCarePlans].choice, _attributeIds.default.acceptsMedicare);
  }
}, {
  key: "clinicalTrials",
  label: "Clinical Trials",
  apply: function apply(location) {
    return location.attributes.clinicalTrials != null && _underscore.default.contains(location.attributes.clinicalTrials.choice, "yes");
  }
}];
exports.checkBoxFilters = checkBoxFilters;

function _applyFilters(locations, filters) {
  var ret = [];
  locations && locations.forEach(function (location) {
    var _filters$medicationsA;

    // eslint-disable-next-line no-unused-vars
    var _iterator = _createForOfIteratorHelper(checkBoxFilters),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var filter = _step.value;

        if (!filters[filter.key]) {
          continue;
        } // bail as soon as the first filter says no


        if (!filter.apply(location)) {
          return;
        }
      } // HACK -- Redo the way filters are applied and fix this

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if ((_filters$medicationsA = filters.medicationsAvailable) !== null && _filters$medicationsA !== void 0 && _filters$medicationsA.length && filters.medicationsAvailable[0].or) {
      var medicationFound = false;

      var _iterator2 = _createForOfIteratorHelper(filters.medicationsAvailable),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _location$attributes$, _location$attributes$2, _location$attributes$3, _location$attributes$4;

          var medication = _step2.value;

          if ((_location$attributes$ = location.attributes[medication.groupKey]) !== null && _location$attributes$ !== void 0 && (_location$attributes$2 = _location$attributes$.choice) !== null && _location$attributes$2 !== void 0 && _location$attributes$2.includes(medication.key) || (_location$attributes$3 = location.attributes[medication.key]) !== null && _location$attributes$3 !== void 0 && (_location$attributes$4 = _location$attributes$3.choice) !== null && _location$attributes$4 !== void 0 && _location$attributes$4.includes(medication.key)) {
            medicationFound = true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (!medicationFound) {
        return;
      }
    } else {
      // eslint-disable-next-line no-unused-vars
      var _iterator3 = _createForOfIteratorHelper(filters.medicationsAvailable),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _medication = _step3.value;

          // let medication = filters.medicationsAvailable[medicationIndex];
          if (!location.attributes[_medication.groupKey] || !location.attributes[_medication.groupKey].choice || !location.attributes[_medication.groupKey].choice.includes(_medication.key)) {
            return;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    if (filters.specialty) {
      // eslint-disable-next-line no-unused-vars
      var _iterator4 = _createForOfIteratorHelper(filters.specialty),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var specialty = _step4.value;

          // const specialtyId = filters.specialty[specialtyIndex];
          if (!location.attributes[_attributeIds.default.practiceSpecialty] || !location.attributes[_attributeIds.default.practiceSpecialty].choice.includes(specialty.key)) {
            return;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    ret.push(location.id);
  });
  return ret;
}
/**
 * Returns the data necessary to render the locationManager list
 */


var useLocationListSelector = function useLocationListSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref) {
    var locations = _ref.locations;
    var locationList = locations.locationIds ? locations.locationIds.map(function (id) {
      return locations.locationMap[id];
    }) : null;
    return _objectSpread(_objectSpread({}, _underscore.default.pick(locations, ["loading", "locationIds", "error"])), {}, {
      locationList: locationList
    });
  });
};

exports.useLocationListSelector = useLocationListSelector;

function _getDefaultFilter() {
  return {
    openWeekends: false,
    acceptsMedicare: false,
    acceptsMedicaid: false,
    hideHospitalBased: false,
    acceptsOutsidePatients: false,
    medicationsAvailable: [],
    specialty: [],
    clinicalTrials: false
  };
}